import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menuButton", "menuIcon", "closeIcon", "mobileMenu"]

  connect() {
    this.scrolled = false
    window.addEventListener("scroll", this.handleScroll.bind(this))
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this))
  }

  handleScroll() {
    const shouldBeScrolled = window.scrollY > 50

    if (shouldBeScrolled !== this.scrolled) {
      this.scrolled = shouldBeScrolled

      if (this.scrolled) {
        this.element.classList.remove("bg-ivory/80", "backdrop-blur-sm", "py-6")
        this.element.classList.add("bg-ivory/95", "backdrop-blur-md", "border-b", "border-beige", "py-4", "shadow-sm")
      } else {
        this.element.classList.remove("bg-ivory/95", "backdrop-blur-md", "border-b", "border-beige", "py-4", "shadow-sm")
        this.element.classList.add("bg-ivory/80", "backdrop-blur-sm", "py-6")
      }
    }
  }

  toggleMenu() {
    const isOpen = !this.mobileMenuTarget.classList.contains("hidden")

    if (isOpen) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  openMenu() {
    this.mobileMenuTarget.classList.remove("hidden")
    this.menuIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
  }

  closeMenu() {
    this.mobileMenuTarget.classList.add("hidden")
    this.menuIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
  }
}
